import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

// eslint-disable-next-line import/prefer-default-export
export const AdvSearchGrid = styled.div`
  display: grid;
  grid-template-columns: 80fr 20fr;
  min-height: 768px;

  @media (${breakpoint.xlMax}) {
    grid-template-columns: 100fr;
  }
`;

export const RightRailContainer = styled.div`   
`;
